import { render, staticRenderFns } from "./sms-info-card.vue?vue&type=template&id=3030989f&scoped=true"
import script from "./sms-info-card.vue?vue&type=script&lang=js"
export * from "./sms-info-card.vue?vue&type=script&lang=js"
import style0 from "./sms-info-card.vue?vue&type=style&index=0&id=3030989f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3030989f",
  null
  
)

export default component.exports